import { render, staticRenderFns } from "./IndGroupView.vue?vue&type=template&id=55e57628&scoped=true&"
import script from "./IndGroupView.vue?vue&type=script&lang=js&"
export * from "./IndGroupView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=55e57628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e57628",
  null
  
)

export default component.exports